export const DATE_FORMATS = {
  parse: {
    dateInput: ['DD.MM.YYYY', 'DD-MM-YYYY', 'DD/MM/YYYY', 'DD MM YYYY'],
    timeInput: 'HH:mm',
  },
  display: {
    dateInput: 'DD.MM.YYYY',
    monthYearLabel: 'MMM. YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
    timeInput: 'HH:mm',
    timeOptionLabel: 'HH:mm',
  },
};
